/**
 * @generated SignedSource<<796f272b41de44a813b8e033188e0d0f>>
 * @relayHash aad5fdbfdd5e61ec5bfd6018ed53cf8a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e2447caf766d3467062126ebea9849f35ab25430924dde7ec1637e46aa3c77e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessSummarySpaAppsQuery } from './BusinessSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3e2447caf766d3467062126ebea9849f35ab25430924dde7ec1637e46aa3c77e",
    "metadata": {},
    "name": "BusinessSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
